import { useQuery, useQueryClient } from 'react-query';
import { getBenefitDetails } from '../api/getBenefitDetails';
import { useRef, useEffect } from 'react';

const useBenefitDetails = (patientID) => {
  const queryClient = useQueryClient();
  const previousPatientID = useRef(null);

  useEffect(() => {
    if (previousPatientID.current !== patientID) {
      queryClient.invalidateQueries(['benefitDetails', patientID]);
      previousPatientID.current = patientID;
    }
  }, [patientID, queryClient]);

  const data = useQuery(['benefitDetails', patientID], () => getBenefitDetails(patientID), {
    refetchOnWindowFocus: true,
    staleTime: 50000,
    enabled: !!patientID,
  });
  return data;
};

export default useBenefitDetails;
